import { Component, input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { OrderDetailsComponent } from '../order-details/order-details.component';
import { OrderData } from '@lfw/roesberg.liveforms.core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lfw-order-details-dialog',
  templateUrl: './order-details-dialog.component.html',
  styleUrls: ['./order-details-dialog.component.css'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    OrderDetailsComponent,
    TranslatePipe
  ]
})
export class OrderDetailsDialogComponent {
  readonly order = input.required<OrderData>();
}
